import React, { useEffect, useRef, useState } from 'react';
import Icon from 'Components/Icon';
import { useSelector } from 'react-redux';
import { classnames } from 'Utils/classnames';
import Popover from 'Components/Popover';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import axios from 'axios';
import ProjectConfig from 'ProjectConfig';
import EnvironmentManager from 'Utils/environmentManager';
import { catchTJKError } from 'Utils/catchTJKError';

const API_GATEWAY = ProjectConfig.API_GATEWAY;

const Predicta = () => {

  const [percent, setPercent] = useState(0);
  const [show, setShow] = useState(true);
  const [infoData, setInfoData] = useState(null);
  const [isCalculated, setIsCalculated] = useState(true);
  const [isPulsing, setIsPulsing] = useState(false);
  const prevPercentRef = useRef(percent);
  const { isAuthenticated } = useSelector(state => state.auth);
  const betSlip = useSelector(state => state.horseRacing.betSlip);
  const { combinedHorses, verify, propositions } = betSlip;

  const isMobile = useMediaQuery({
    query: '(max-width: 768px)'
  });

  const calculatePercent = () => {
    if (isAuthenticated && verify?.data?.success) {
      const propositionIds = combinedHorses?.length > 0 ? combinedHorses.map(item => item?.horse?.propositionInfo?.propositionId) : propositions.map(item => item?.proposition?.propositionId);
      axios.post(`${API_GATEWAY}/product/fixodds/predicta/compute`, { propositionIds }).then(response => {
        catchTJKError(response?.data);
        const { winningProbability, info } = response?.data?.body;
        setIsCalculated(winningProbability !== null);
        if (winningProbability) {
          setPercent(winningProbability);
        } else if (info)  {
          setPercent(80);
          setInfoData(info);
        }

      }).catch(e => console.log('predicta calculation error', e));
    }
  };


  useEffect(()=> {
    if (combinedHorses?.length > 0) {
      calculatePercent();
    } else if (propositions?.length > 0) {
      calculatePercent();
    }
    if (!isAuthenticated && verify?.data?.success) {
      setPercent(80);
    }
  }, [combinedHorses, isAuthenticated, verify?.data?.success, propositions]);


  useEffect(() => {
    const prev = Number(prevPercentRef.current) || 0;
    const next = Number(percent) || 0;
    let timeout;
    if (next > prev) {
      setIsPulsing(true);
      timeout = setTimeout(() => setIsPulsing(false), 500);
    }
    prevPercentRef.current = next;
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [percent]);

  return (show && verify?.data?.success && percent > 0) ? <div className={
    classnames({
      predictaHorseRacing: true,
      isMobile: isMobile
    })
  }>
    <div onClick={ () => setShow(false) } className="close">
      <Icon iconName="svgCloseDelete" />
    </div>
    { isCalculated ? <>

      <div className="percent-info">
        <div className="text">
          { EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.predicta_title' }) }
        </div>
        <div className={ classnames({
          percent: true,
          blur: !isAuthenticated,
          pulse: isPulsing
        }) }>
          %{ percent }
        </div>
      </div>
      <div className="percent-bar">
        <div style={ { width: `${percent}%` } } className="percent-full"/>
      </div>
      {
        isAuthenticated ? <div className="info-text">
          { EnvironmentManager.getMessageText({ key: 'v1.betslip_fixodd.predicta_desc' }) }
        </div> : <Link to="/giris-yap" className="show-percent-button">İHTİMALİ GÖR</Link>
      }
    </> : <div className="not-calculated" >
      <div dangerouslySetInnerHTML={ { __html: infoData?.title } } className="text" />
      <Popover
        content={ <div dangerouslySetInnerHTML={ { __html: infoData?.description } } className="not-calculated-message" /> }
        position="top-right"
        offset={ 12 }
      >
        <Icon iconName="svgInfo" />
      </Popover>
    </div> }

  </div> : null;
};

export default Predicta;
